import { ReactNode } from 'react';

import Green from '@/generic/Green/Green';

const GreenChunk = (_chunks: ReactNode) => <Green>{_chunks}</Green>;

export default GreenChunk;
